"use client";

import Link from "next/link";
import { Heading } from "@repo/ui/heading";
import { BaseImage, absoluteCmsUrl } from "../base-image/BaseImage";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import type { Room } from "../../lib/rooms";

export default function RoomCard({
  room,
  tallOffset = false,
}: {
  room: Room;
  tallOffset?: boolean;
}) {
  const raw =
    room.image?.formats?.large?.url ||
    room.image?.formats?.medium?.url ||
    room.image?.url ||
    "";
  const src = raw ? absoluteCmsUrl(raw) : "";
  const alt =
    room.image?.alternativeText ||
    room.image?.caption ||
    room.image?.name ||
    room.title;

  return (
    <Link
      href={`/rooms/${room.alias}`}
      className={`flex flex-col gap-5 md:w-1/2 w-full ${tallOffset ? "sm:mt-20" : ""}`}
      aria-label={`${room.title} — view details`}
    >
      <div className="relative w-full h-[535px]">
        {src ? (
          <BaseImage
            src={src}
            alt={alt}
            fill
            sizes="(max-width:640px) 100vw, (max-width:1024px) 50vw, 33vw"
            className="object-cover object-center"
            priority={tallOffset}
          />
        ) : null}
      </div>
      <div className="flex flex-col gap-2.5">
        <Heading
          level="h5"
          className="text-2xl uppercase font-noto"
          title={room.title}
        />
        {room.shortDescription ? (
          <div className="tracking-tight max-w-sm text-base">
            {room.shortDescription}
          </div>
        ) : null}
      </div>
    </Link>
  );
}
